import { useState } from "react";

const MOT_DE_PASSE = "Kemidrone2026!";

const STAGES = [
  { id: "nouveau", label: "Nouveau lead", color: "#6366f1" },
  { id: "contacte", label: "Contacté", color: "#f59e0b" },
  { id: "qualification", label: "Qualification", color: "#06b6d4" },
  { id: "visite", label: "Visite terrain", color: "#f97316" },
  { id: "devis", label: "Devis envoyé", color: "#3b82f6" },
  { id: "relance1", label: "Relance J+3", color: "#a855f7" },
  { id: "relance2", label: "Relance J+7", color: "#ec4899" },
  { id: "relance3", label: "Relance J+14", color: "#FA0A96" },
  { id: "negociation", label: "Négociation", color: "#8b5cf6" },
  { id: "contrat", label: "Contrat annuel", color: "#14b8a6" },
  { id: "planifie", label: "Planifié", color: "#84cc16" },
  { id: "gagne", label: "Gagné", color: "#10b981" },
  { id: "perdu", label: "Perdu", color: "#ef4444" },
];

const TODAY = "2026-05-19";
const genId = () => Math.random().toString(36).slice(2, 9);
const eur = (n) => new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n || 0);
const initials = (nom) => nom.split(" ").slice(0, 2).map(w => w[0]).join("").toUpperCase();
const stageColor = (id) => STAGES.find(s => s.id === id)?.color || "#6b7280";
const stageLabel = (id) => STAGES.find(s => s.id === id)?.label || id;

const INIT_CONTACTS = [
  { id: "c1", nom: "DomusVi Les Hautes Futaies", email: "contact@domusvi.fr", tel: "01 45 67 89 00", stage: "negociation", valeur: 4800, tags: ["EHPAD", "Récurrent"], notes: [{ text: "Contrat annuel en cours.", date: "2026-05-15" }], createdAt: "2026-04-10", lastActivity: "2026-05-15" },
  { id: "c2", nom: "APRR Direction IDF", email: "dr.idf@aprr.fr", tel: "01 60 00 12 34", stage: "relance1", valeur: 12000, tags: ["Autoroute", "Grand compte"], notes: [{ text: "Devis multi-sites envoyé.", date: "2026-05-02" }], createdAt: "2026-03-22", lastActivity: "2026-05-10" },
  { id: "c3", nom: "PAPREC Entrepôt 77", email: "maintenance@paprec.com", tel: "01 64 00 45 67", stage: "devis", valeur: 3200, tags: ["Industriel"], notes: [{ text: "600m² poutres + parois.", date: "2026-04-28" }], createdAt: "2026-04-28", lastActivity: "2026-05-08" },
  { id: "c4", nom: "AREAS Eiffage A10", email: "exploitation@areas.fr", tel: "01 69 00 78 90", stage: "contacte", valeur: 9500, tags: ["Autoroute", "Façade"], notes: [], createdAt: "2026-04-20", lastActivity: "2026-04-25" },
  { id: "c5", nom: "Esso Station Évry", email: "responsable@esso-evry.fr", tel: "01 60 79 00 11", stage: "nouveau", valeur: 1800, tags: ["Station-service"], notes: [], createdAt: "2026-05-12", lastActivity: "2026-05-12" },
  { id: "c6", nom: "Syndic Citya Essonne", email: "gestion@citya-essonne.fr", tel: "01 69 45 00 33", stage: "gagne", valeur: 6400, tags: ["Syndic", "Toiture"], notes: [{ text: "Contrat signé. Intervention juin.", date: "2026-05-01" }], createdAt: "2026-02-14", lastActivity: "2026-05-01" },
  { id: "c7", nom: "Foncia Gestion IDF", email: "idf@foncia.fr", tel: "01 42 00 33 11", stage: "qualification", valeur: 5200, tags: ["Syndic", "Multi-sites"], notes: [], createdAt: "2026-05-05", lastActivity: "2026-05-05" },
  { id: "c8", nom: "Centre Commercial Évry 2", email: "tech@evry2.fr", tel: "01 60 78 00 55", stage: "visite", valeur: 18000, tags: ["Retail"], notes: [{ text: "Visite terrain 22/05.", date: "2026-05-12" }], createdAt: "2026-05-01", lastActivity: "2026-05-12" },
];

const INIT_MESSAGES = [
  { id: "m1", contactId: "c2", direction: "out", texte: "Bonjour, je reviens vers vous concernant notre devis multi-sites.", date: "2026-05-10" },
  { id: "m2", contactId: "c2", direction: "in", texte: "Merci, nous regardons cela avec notre direction technique.", date: "2026-05-11" },
  { id: "m3", contactId: "c1", direction: "out", texte: "Je vous transmets le projet de contrat annuel comme convenu.", date: "2026-05-15" },
  { id: "m4", contactId: "c3", direction: "out", texte: "Devis ref KD-2026-047 pour nettoyage entrepôt 600m².", date: "2026-05-08" },
];

const INIT_RDVS = [
  { id: "r1", titre: "Visite terrain Évry 2", contact: "Centre Commercial Évry 2", date: "2026-05-22", heure: "10:00", type: "terrain", statut: "confirme" },
  { id: "r2", titre: "Appel DomusVi contrat", contact: "DomusVi Les Hautes Futaies", date: "2026-05-27", heure: "14:30", type: "appel", statut: "confirme" },
  { id: "r3", titre: "Présentation APRR", contact: "APRR Direction IDF", date: "2026-06-03", heure: "09:00", type: "presentiel", statut: "tentative" },
];

const INIT_AUTOS = [
  { id: "a1", nom: "Relance J+3 après devis", declencheur: "devis", delai: 3, canal: "email", actif: true, envoyes: 12, ouverts: 9, reponses: 4 },
  { id: "a2", nom: "Relance J+7 sans réponse", declencheur: "relance1", delai: 7, canal: "email", actif: true, envoyes: 7, ouverts: 5, reponses: 2 },
  { id: "a3", nom: "Relance J+14 finale", declencheur: "relance2", delai: 14, canal: "email", actif: true, envoyes: 4, ouverts: 3, reponses: 1 },
  { id: "a4", nom: "SMS confirmation RDV terrain", declencheur: "visite", delai: 1, canal: "sms", actif: true, envoyes: 8, ouverts: 8, reponses: 6 },
  { id: "a5", nom: "Email bienvenue nouveau lead", declencheur: "nouveau", delai: 0, canal: "email", actif: false, envoyes: 0, ouverts: 0, reponses: 0 },
];

const css = {
  root: { display: "flex", height: "100vh", background: "#080e1a", fontFamily: "'DM Sans','Segoe UI',sans-serif", color: "#cbd5e1", overflow: "hidden", fontSize: 13 },
  sidebar: { width: 220, background: "#0c1322", borderRight: "1px solid #1a2540", display: "flex", flexDirection: "column", flexShrink: 0 },
  logo: { padding: "18px 16px", borderBottom: "1px solid #1a2540", display: "flex", alignItems: "center", gap: 10 },
  logoMark: { width: 32, height: 32, borderRadius: 8, background: "linear-gradient(135deg,#FA0A96,#7c3aed)", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, color: "#fff", fontSize: 15 },
  logoText: { fontSize: 16, fontWeight: 800, color: "#f1f5f9" },
  nav: { flex: 1, padding: "12px 8px", overflowY: "auto" },
  navSec: { fontSize: 10, fontWeight: 700, color: "#334155", textTransform: "uppercase", letterSpacing: 1, padding: "8px 8px 3px" },
  navBtn: (a) => ({ display: "flex", alignItems: "center", gap: 9, width: "100%", padding: "8px 10px", borderRadius: 7, border: "none", background: a ? "#1a2a4a" : "transparent", color: a ? "#f1f5f9" : "#64748b", fontSize: 12, fontWeight: a ? 700 : 500, cursor: "pointer", marginBottom: 1, textAlign: "left" }),
  badge: (c) => ({ background: c || "#FA0A96", borderRadius: 10, padding: "1px 6px", fontSize: 10, fontWeight: 800, color: "#fff", marginLeft: "auto" }),
  sideBot: { borderTop: "1px solid #1a2540", padding: 14 },
  statsGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6, marginBottom: 12 },
  statCard: { background: "#111827", borderRadius: 7, padding: "8px 10px" },
  statVal: (c) => ({ fontSize: 14, fontWeight: 800, color: c || "#f1f5f9" }),
  statLbl: { fontSize: 10, color: "#475569", marginTop: 2 },
  userRow: { display: "flex", alignItems: "center", gap: 8 },
  av: (bg, sz) => ({ width: sz || 34, height: sz || 34, borderRadius: "50%", background: bg || "#FA0A96", display: "flex", alignItems: "center", justifyContent: "center", fontSize: (sz || 34) * 0.35, fontWeight: 800, color: "#fff", flexShrink: 0 }),
  main: { flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" },
  topbar: { display: "flex", alignItems: "center", gap: 10, padding: "12px 18px", borderBottom: "1px solid #1a2540", background: "#0c1322", flexShrink: 0 },
  searchBox: { flex: 1, background: "#111827", border: "1px solid #1e2d4a", borderRadius: 7, padding: "7px 12px", color: "#f1f5f9", fontSize: 13, outline: "none" },
  btnP: { background: "linear-gradient(135deg,#FA0A96,#c2006e)", border: "none", borderRadius: 7, padding: "8px 16px", color: "#fff", fontSize: 12, fontWeight: 700, cursor: "pointer" },
  btnG: { background: "#1a2540", border: "1px solid #1e2d4a", borderRadius: 7, padding: "7px 12px", color: "#94a3b8", fontSize: 12, cursor: "pointer" },
  btnD: { background: "transparent", border: "1px solid #ef444433", borderRadius: 5, padding: "3px 8px", color: "#ef4444", fontSize: 11, cursor: "pointer" },
  content: { flex: 1, overflow: "auto" },
  kanban: { display: "flex", gap: 8, padding: "14px", overflowX: "auto", alignItems: "flex-start" },
  col: { minWidth: 190, flex: "0 0 190px", background: "#0c1322", borderRadius: 9, border: "1px solid #1a2540" },
  colH: { padding: "10px 10px 6px", borderBottom: "1px solid #1a2540" },
  colT: { display: "flex", alignItems: "center", gap: 6, fontSize: 11, fontWeight: 700, color: "#e2e8f0" },
  dot: (c) => ({ width: 7, height: 7, borderRadius: "50%", background: c, flexShrink: 0 }),
  cnt: { background: "#1a2540", borderRadius: 10, padding: "1px 6px", fontSize: 10, color: "#94a3b8", fontWeight: 700, marginLeft: "auto" },
  colTotal: { fontSize: 10, color: "#475569", padding: "3px 10px 7px" },
  cards: { padding: 7, display: "flex", flexDirection: "column", gap: 6, minHeight: 40 },
  card: { background: "#111827", border: "1px solid #1e2d4a", borderRadius: 8, padding: 10, cursor: "grab" },
  cardName: { fontSize: 11, fontWeight: 700, color: "#e2e8f0", marginBottom: 2, lineHeight: 1.3 },
  cardMeta: { fontSize: 10, color: "#475569", marginBottom: 7 },
  cardFoot: { display: "flex", alignItems: "center", justifyContent: "space-between" },
  cardVal: { fontSize: 11, fontWeight: 800, color: "#10b981" },
  tags: { display: "flex", gap: 3, flexWrap: "wrap" },
  tag: { background: "#1a2540", borderRadius: 3, padding: "1px 5px", fontSize: 9, color: "#94a3b8", fontWeight: 600 },
  tableWrap: { padding: "16px 20px" },
  table: { width: "100%", borderCollapse: "collapse" },
  th: { textAlign: "left", padding: "8px 10px", fontSize: 10, color: "#475569", fontWeight: 700, borderBottom: "1px solid #1a2540", textTransform: "uppercase", letterSpacing: 0.5 },
  tr: { borderBottom: "1px solid #1a2540", cursor: "pointer" },
  td: { padding: "10px 10px", fontSize: 12, color: "#94a3b8" },
  sbadge: (c) => ({ borderRadius: 5, padding: "2px 8px", fontSize: 10, fontWeight: 700, background: c + "22", color: c, border: `1px solid ${c}44` }),
  ficheWrap: { padding: "16px 20px" },
  ficheGrid: { display: "grid", gridTemplateColumns: "260px 1fr", gap: 16 },
  card2: { background: "#0c1322", border: "1px solid #1a2540", borderRadius: 11, padding: 18, marginBottom: 12 },
  secT: { fontSize: 12, fontWeight: 800, color: "#e2e8f0", marginBottom: 12, paddingBottom: 7, borderBottom: "1px solid #1a2540" },
  flbl: { fontSize: 10, color: "#475569", fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 3 },
  inp: { width: "100%", background: "#111827", border: "1px solid #1e2d4a", borderRadius: 6, padding: "7px 10px", color: "#f1f5f9", fontSize: 12, outline: "none", boxSizing: "border-box", marginBottom: 10 },
  sel: { width: "100%", background: "#111827", border: "1px solid #1e2d4a", borderRadius: 6, padding: "7px 10px", color: "#f1f5f9", fontSize: 12, outline: "none", boxSizing: "border-box" },
  ta: { width: "100%", background: "#111827", border: "1px solid #1e2d4a", borderRadius: 6, padding: "8px 10px", color: "#f1f5f9", fontSize: 12, outline: "none", resize: "none", height: 64, boxSizing: "border-box" },
  noteItem: { display: "flex", gap: 8, padding: "8px 0", borderBottom: "1px solid #111827" },
  noteDot: { width: 6, height: 6, borderRadius: "50%", background: "#FA0A96", flexShrink: 0, marginTop: 5 },
  inboxGrid: { display: "grid", gridTemplateColumns: "260px 1fr" },
  inboxL: { borderRight: "1px solid #1a2540", overflowY: "auto" },
  inboxItem: (a) => ({ padding: "12px 14px", borderBottom: "1px solid #1a2540", cursor: "pointer", background: a ? "#111827" : "transparent" }),
  bubble: (d) => ({ maxWidth: "72%", alignSelf: d === "out" ? "flex-end" : "flex-start", background: d === "out" ? "linear-gradient(135deg,#FA0A96,#7c3aed)" : "#1a2540", borderRadius: d === "out" ? "12px 12px 3px 12px" : "12px 12px 12px 3px", padding: "9px 13px", fontSize: 12, color: "#f1f5f9", lineHeight: 1.5 }),
  calWrap: { padding: "16px 20px" },
  calGrid: { display: "grid", gridTemplateColumns: "1fr 290px", gap: 16 },
  calDays: { display: "grid", gridTemplateColumns: "repeat(7,1fr)", gap: 1, marginBottom: 1 },
  calDay: { background: "#0c1322", padding: "5px", fontSize: 10, fontWeight: 700, color: "#475569", textAlign: "center" },
  calCells: { display: "grid", gridTemplateColumns: "repeat(7,1fr)", gap: 1 },
  calCell: (today) => ({ background: today ? "#1a2a4a" : "#0c1322", border: `1px solid ${today ? "#FA0A96" : "#1a2540"}`, borderRadius: 5, padding: "5px 6px", minHeight: 60, cursor: "pointer" }),
  calNum: (today) => ({ fontSize: 11, fontWeight: today ? 800 : 400, color: today ? "#FA0A96" : "#64748b", marginBottom: 3 }),
  calEv: (c) => ({ background: c + "33", border: `1px solid ${c}66`, borderRadius: 3, padding: "1px 4px", fontSize: 9, color: c, fontWeight: 700, marginBottom: 1, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }),
  rdvCard: { background: "#0c1322", border: "1px solid #1a2540", borderRadius: 9, padding: "11px 14px", marginBottom: 8, display: "flex", gap: 10 },
  autoWrap: { padding: "16px 20px" },
  autoCard: { background: "#0c1322", border: "1px solid #1a2540", borderRadius: 11, padding: 16, marginBottom: 10 },
  statsRow: { display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 8, marginTop: 10 },
  autoStat: { background: "#111827", borderRadius: 7, padding: "9px 10px", textAlign: "center" },
  toggle: (on) => ({ width: 38, height: 20, borderRadius: 10, background: on ? "#10b981" : "#1a2540", border: "none", position: "relative", cursor: "pointer", transition: "background 0.2s", flexShrink: 0 }),
  toggleDot: (on) => ({ position: "absolute", top: 3, left: on ? 20 : 3, width: 14, height: 14, borderRadius: "50%", background: "#fff", transition: "left 0.2s" }),
  repWrap: { padding: "16px 20px" },
  kpiGrid: { display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginBottom: 16 },
  kpiCard: { background: "#0c1322", border: "1px solid #1a2540", borderRadius: 11, padding: "16px 18px" },
  kpiVal: (c) => ({ fontSize: 24, fontWeight: 900, color: c || "#f1f5f9", lineHeight: 1 }),
  barRow: { display: "flex", alignItems: "center", gap: 8, marginBottom: 8 },
  barLbl: { width: 150, fontSize: 11, color: "#94a3b8", textAlign: "right", flexShrink: 0 },
  barTrack: { flex: 1, height: 7, background: "#111827", borderRadius: 3, overflow: "hidden" },
  barFill: (p, c) => ({ width: `${p}%`, height: "100%", background: c, borderRadius: 3 }),
  overlay: { position: "fixed", inset: 0, background: "rgba(0,0,0,0.75)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 },
  modal: { background: "#0c1322", border: "1px solid #1a2540", borderRadius: 13, padding: 26, width: 420, maxHeight: "88vh", overflowY: "auto" },
  backBtn: { background: "none", border: "none", color: "#64748b", fontSize: 12, cursor: "pointer", padding: 0, marginBottom: 14 },
  flowBadge: (c) => ({ background: c + "22", color: c, borderRadius: 5, padding: "2px 8px", fontSize: 10, fontWeight: 700, border: `1px solid ${c}44` }),
};

function Av({ nom, stage, sz }) {
  return <div style={css.av(stageColor(stage), sz)}>{initials(nom)}</div>;
}

function Login({ onLogin }) {
  const [pwd, setPwd] = useState("");
  const [erreur, setErreur] = useState(false);
  const check = () => {
    if (pwd === MOT_DE_PASSE) { onLogin(); }
    else { setErreur(true); setTimeout(() => setErreur(false), 2000); }
  };
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", background: "#080e1a" }}>
      <div style={{ background: "#0c1322", border: "1px solid #1a2540", borderRadius: 14, padding: 40, width: 340, textAlign: "center" }}>
        <div style={{ width: 48, height: 48, borderRadius: 12, background: "linear-gradient(135deg,#FA0A96,#7c3aed)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, fontWeight: 900, color: "#fff", margin: "0 auto 20px" }}>K</div>
        <div style={{ fontSize: 20, fontWeight: 800, color: "#f1f5f9", marginBottom: 6 }}>KemiCRM</div>
        <div style={{ fontSize: 13, color: "#475569", marginBottom: 28 }}>Accès privé Kemidrone</div>
        <input type="password" style={{ width: "100%", background: "#111827", border: `1px solid ${erreur ? "#ef4444" : "#1e2d4a"}`, borderRadius: 8, padding: "10px 14px", color: "#f1f5f9", fontSize: 14, outline: "none", boxSizing: "border-box", marginBottom: 12 }}
          placeholder="Mot de passe" value={pwd} onChange={e => setPwd(e.target.value)} onKeyDown={e => e.key === "Enter" && check()} />
        {erreur && <div style={{ color: "#ef4444", fontSize: 12, marginBottom: 10 }}>Mot de passe incorrect</div>}
        <button style={{ width: "100%", background: "linear-gradient(135deg,#FA0A96,#c2006e)", border: "none", borderRadius: 8, padding: "11px", color: "#fff", fontSize: 14, fontWeight: 700, cursor: "pointer" }} onClick={check}>
          Accéder au CRM
        </button>
      </div>
    </div>
  );
}

function Pipeline({ contacts, setContacts, onSelect }) {
  const [dragId, setDragId] = useState(null);
  const byStage = (id) => contacts.filter(c => c.stage === id);
  return (
    <div style={css.kanban}>
      {STAGES.map(s => (
        <div key={s.id} style={css.col} onDragOver={e => e.preventDefault()}
          onDrop={() => { if (dragId) { setContacts(p => p.map(c => c.id === dragId ? { ...c, stage: s.id, lastActivity: TODAY } : c)); setDragId(null); } }}>
          <div style={css.colH}>
            <div style={css.colT}><div style={css.dot(s.color)} />{s.label}<span style={css.cnt}>{byStage(s.id).length}</span></div>
          </div>
          <div style={css.colTotal}>{eur(byStage(s.id).reduce((a, c) => a + c.valeur, 0))}</div>
          <div style={css.cards}>
            {byStage(s.id).map(c => (
              <div key={c.id} style={css.card} draggable onDragStart={() => setDragId(c.id)} onClick={() => onSelect(c.id)}>
                <div style={{ display: "flex", gap: 7, marginBottom: 7 }}>
                  <Av nom={c.nom} stage={c.stage} sz={28} />
                  <div><div style={css.cardName}>{c.nom}</div><div style={css.cardMeta}>{c.email}</div></div>
                </div>
                <div style={css.cardFoot}>
                  <span style={css.cardVal}>{eur(c.valeur)}</span>
                  <div style={css.tags}>{c.tags.slice(0, 1).map(t => <span key={t} style={css.tag}>{t}</span>)}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

function Contacts({ contacts, setContacts, search, onSelect }) {
  const f = contacts.filter(c => c.nom.toLowerCase().includes(search.toLowerCase()) || c.email.toLowerCase().includes(search.toLowerCase()) || c.tags.some(t => t.toLowerCase().includes(search.toLowerCase())));
  return (
    <div style={css.tableWrap}>
      <table style={css.table}>
        <thead><tr>{["Contact", "Email", "Tél", "Stage", "Valeur", "Activité", ""].map(h => <th key={h} style={css.th}>{h}</th>)}</tr></thead>
        <tbody>
          {f.map(c => (
            <tr key={c.id} style={css.tr} onClick={() => onSelect(c.id)}>
              <td style={css.td}><div style={{ display: "flex", alignItems: "center", gap: 8 }}><Av nom={c.nom} stage={c.stage} sz={30} /><div><div style={{ fontWeight: 700, color: "#f1f5f9" }}>{c.nom}</div><div style={css.tags}>{c.tags.map(t => <span key={t} style={css.tag}>{t}</span>)}</div></div></div></td>
              <td style={css.td}>{c.email}</td>
              <td style={css.td}>{c.tel}</td>
              <td style={css.td}><span style={css.sbadge(stageColor(c.stage))}>{stageLabel(c.stage)}</span></td>
              <td style={{ ...css.td, fontWeight: 800, color: "#10b981" }}>{eur(c.valeur)}</td>
              <td style={{ ...css.td, color: "#475569" }}>{c.lastActivity}</td>
              <td style={css.td}><button style={css.btnD} onClick={e => { e.stopPropagation(); setContacts(p => p.filter(x => x.id !== c.id)); }}>✕</button></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function Fiche({ contact, contacts, setContacts, messages, setMessages, onBack }) {
  const [note, setNote] = useState("");
  const [msg, setMsg] = useState("");
  const convMsgs = messages.filter(m => m.contactId === contact.id);
  const upd = (patch) => setContacts(p => p.map(c => c.id === contact.id ? { ...c, ...patch, lastActivity: TODAY } : c));
  const addNote = () => { if (!note.trim()) return; upd({ notes: [...contact.notes, { text: note.trim(), date: TODAY }] }); setNote(""); };
  const send = () => { if (!msg.trim()) return; setMessages(p => [...p, { id: genId(), contactId: contact.id, direction: "out", texte: msg.trim(), date: TODAY }]); setMsg(""); };
  return (
    <div style={css.ficheWrap}>
      <button style={css.backBtn} onClick={onBack}>← Retour</button>
      <div style={css.ficheGrid}>
        <div>
          <div style={{ ...css.card2, textAlign: "center" }}>
            <Av nom={contact.nom} stage={contact.stage} sz={56} />
            <div style={{ marginTop: 10, fontSize: 15, fontWeight: 800, color: "#f1f5f9" }}>{contact.nom}</div>
            <div style={{ fontSize: 11, color: "#64748b", margin: "3px 0" }}>{contact.email}</div>
            <div style={{ fontSize: 11, color: "#64748b" }}>{contact.tel}</div>
            <div style={{ marginTop: 12 }}><div style={css.flbl}>Stage</div>
              <select style={css.sel} value={contact.stage} onChange={e => upd({ stage: e.target.value })}>
                {STAGES.map(s => <option key={s.id} value={s.id}>{s.label}</option>)}
              </select>
            </div>
            <div style={{ marginTop: 10 }}><div style={css.flbl}>Valeur</div><div style={{ fontSize: 22, fontWeight: 900, color: "#10b981" }}>{eur(contact.valeur)}</div></div>
            <div style={{ marginTop: 10, display: "flex", flexWrap: "wrap", gap: 4, justifyContent: "center" }}>{contact.tags.map(t => <span key={t} style={css.tag}>{t}</span>)}</div>
            <div style={{ marginTop: 12, fontSize: 10, color: "#334155" }}>Créé le {contact.createdAt} · Activité {contact.lastActivity}</div>
            <button style={{ ...css.btnD, width: "100%", marginTop: 14 }} onClick={() => { setContacts(p => p.filter(c => c.id !== contact.id)); onBack(); }}>Supprimer</button>
          </div>
          <div style={css.card2}>
            <div style={css.secT}>Progression pipeline</div>
            {STAGES.map((s, i) => { const ci = STAGES.findIndex(x => x.id === contact.stage); const past = i <= ci;
              return <div key={s.id} style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 5, cursor: "pointer" }} onClick={() => upd({ stage: s.id })}>
                <div style={{ width: 9, height: 9, borderRadius: "50%", background: past ? s.color : "#1a2540", border: `2px solid ${past ? s.color : "#334155"}`, flexShrink: 0, transform: contact.stage === s.id ? "scale(1.4)" : "scale(1)" }} />
                <div style={{ fontSize: 11, color: past ? "#e2e8f0" : "#475569", fontWeight: contact.stage === s.id ? 800 : 400 }}>{s.label}</div>
              </div>;
            })}
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <div style={css.card2}>
            <div style={css.secT}>Conversation</div>
            <div style={{ maxHeight: 200, overflowY: "auto", marginBottom: 10, display: "flex", flexDirection: "column", gap: 7 }}>
              {convMsgs.length === 0 && <div style={{ color: "#334155", fontSize: 12 }}>Aucun message.</div>}
              {convMsgs.map(m => <div key={m.id} style={{ alignSelf: m.direction === "out" ? "flex-end" : "flex-start", maxWidth: "80%" }}>
                <div style={css.bubble(m.direction)}>{m.texte}</div>
                <div style={{ fontSize: 10, color: "#334155", marginTop: 2, textAlign: m.direction === "out" ? "right" : "left" }}>{m.date}</div>
              </div>)}
            </div>
            <div style={{ display: "flex", gap: 7 }}>
              <input style={{ ...css.inp, marginBottom: 0, flex: 1 }} placeholder="Envoyer un email..." value={msg} onChange={e => setMsg(e.target.value)} onKeyDown={e => e.key === "Enter" && send()} />
              <button style={css.btnP} onClick={send}>Envoyer</button>
            </div>
          </div>
          <div style={css.card2}>
            <div style={css.secT}>Notes</div>
            <div style={{ maxHeight: 160, overflowY: "auto", marginBottom: 10 }}>
              {contact.notes.length === 0 && <div style={{ color: "#334155", fontSize: 12 }}>Aucune note.</div>}
              {contact.notes.map((n, i) => <div key={i} style={css.noteItem}><div style={css.noteDot} /><div><div style={{ fontSize: 12, color: "#94a3b8" }}>{n.text}</div><div style={{ fontSize: 10, color: "#475569", marginTop: 2 }}>{n.date}</div></div></div>)}
            </div>
            <div style={{ display: "flex", gap: 7, alignItems: "flex-end" }}>
              <textarea style={{ ...css.ta, flex: 1 }} placeholder="Ajouter une note..." value={note} onChange={e => setNote(e.target.value)} />
              <button style={css.btnP} onClick={addNote}>Ajouter</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Conversations({ contacts, messages, setMessages }) {
  const [activeId, setActiveId] = useState(contacts[0]?.id || null);
  const [msg, setMsg] = useState("");
  const threads = contacts.map(c => { const msgs = messages.filter(m => m.contactId === c.id); return { c, last: msgs[msgs.length - 1] }; }).filter(t => t.last);
  const activeC = contacts.find(c => c.id === activeId);
  const activeMsgs = messages.filter(m => m.contactId === activeId);
  const send = () => { if (!msg.trim() || !activeId) return; setMessages(p => [...p, { id: genId(), contactId: activeId, direction: "out", texte: msg.trim(), date: TODAY }]); setMsg(""); };
  return (
    <div style={{ ...css.inboxGrid, height: "calc(100vh - 58px)" }}>
      <div style={css.inboxL}>
        <div style={{ padding: "10px 12px", borderBottom: "1px solid #1a2540", fontSize: 12, fontWeight: 700, color: "#e2e8f0" }}>Inbox</div>
        {threads.map(({ c, last }) => <div key={c.id} style={css.inboxItem(activeId === c.id)} onClick={() => setActiveId(c.id)}>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <Av nom={c.nom} stage={c.stage} sz={28} />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: "#e2e8f0" }}>{c.nom}</div>
              <div style={{ fontSize: 11, color: "#475569", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>{last?.texte}</div>
            </div>
          </div>
        </div>)}
      </div>
      {activeC ? <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ padding: "12px 16px", borderBottom: "1px solid #1a2540", display: "flex", alignItems: "center", gap: 10 }}>
          <Av nom={activeC.nom} stage={activeC.stage} sz={32} />
          <div><div style={{ fontWeight: 700, color: "#f1f5f9", fontSize: 13 }}>{activeC.nom}</div><div style={{ fontSize: 10, color: "#64748b" }}>{activeC.email}</div></div>
          <span style={{ ...css.sbadge(stageColor(activeC.stage)), marginLeft: "auto" }}>{stageLabel(activeC.stage)}</span>
        </div>
        <div style={{ flex: 1, overflowY: "auto", padding: "14px 16px", display: "flex", flexDirection: "column", gap: 8 }}>
          {activeMsgs.map(m => <div key={m.id} style={{ alignSelf: m.direction === "out" ? "flex-end" : "flex-start", maxWidth: "72%" }}>
            <div style={css.bubble(m.direction)}>{m.texte}</div>
            <div style={{ fontSize: 10, color: "#475569", marginTop: 2, textAlign: m.direction === "out" ? "right" : "left" }}>{m.date}</div>
          </div>)}
          {activeMsgs.length === 0 && <div style={{ color: "#334155", fontSize: 12, textAlign: "center", marginTop: 30 }}>Démarrez la conversation.</div>}
        </div>
        <div style={{ padding: "10px 16px", borderTop: "1px solid #1a2540", display: "flex", gap: 8 }}>
          <input style={{ ...css.inp, flex: 1, marginBottom: 0 }} placeholder="Votre message..." value={msg} onChange={e => setMsg(e.target.value)} onKeyDown={e => e.key === "Enter" && send()} />
          <button style={css.btnP} onClick={send}>Envoyer</button>
        </div>
      </div> : <div style={{ display: "flex", alignItems: "center", justifyContent: "center", color: "#334155" }}>Sélectionnez une conversation</div>}
    </div>
  );
}

function Calendrier({ rdvs, setRdvs }) {
  const [month, setMonth] = useState(new Date(2026, 4, 1));
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ titre: "", contact: "", date: "", heure: "10:00", type: "appel" });
  const y = month.getFullYear(), m = month.getMonth();
  const fd = new Date(y, m, 1).getDay();
  const dim = new Date(y, m + 1, 0).getDate();
  const off = fd === 0 ? 6 : fd - 1;
  const cells = Array.from({ length: 42 }, (_, i) => { const d = i - off + 1; return (d < 1 || d > dim) ? null : d; });
  const rdvsDay = (d) => { if (!d) return []; const ds = `${y}-${String(m + 1).padStart(2, "0")}-${String(d).padStart(2, "0")}`; return rdvs.filter(r => r.date === ds); };
  const tc = { terrain: "#FA0A96", appel: "#3b82f6", presentiel: "#10b981" };
  const mns = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
  const create = () => { if (!form.titre || !form.date) return; setRdvs(p => [...p, { id: genId(), ...form, statut: "confirme" }]); setShowModal(false); setForm({ titre: "", contact: "", date: "", heure: "10:00", type: "appel" }); };
  return (
    <div style={css.calWrap}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
        <button style={css.btnG} onClick={() => setMonth(new Date(y, m - 1, 1))}>←</button>
        <div style={{ fontSize: 15, fontWeight: 800, color: "#f1f5f9", flex: 1 }}>{mns[m]} {y}</div>
        <button style={css.btnG} onClick={() => setMonth(new Date(y, m + 1, 1))}>→</button>
        <button style={css.btnP} onClick={() => setShowModal(true)}>+ RDV</button>
      </div>
      <div style={css.calGrid}>
        <div>
          <div style={css.calDays}>{["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"].map(d => <div key={d} style={css.calDay}>{d}</div>)}</div>
          <div style={css.calCells}>
            {cells.map((d, i) => { const ev = rdvsDay(d); const today = d === 19 && m === 4 && y === 2026; return <div key={i} style={css.calCell(today)}>{d && <><div style={css.calNum(today)}>{d}</div>{ev.map(r => <div key={r.id} style={css.calEv(tc[r.type] || "#6366f1")}>{r.heure} {r.titre}</div>)}</>}</div>; })}
          </div>
        </div>
        <div>
          <div style={{ fontSize: 12, fontWeight: 700, color: "#e2e8f0", marginBottom: 10 }}>Prochains RDV</div>
          {rdvs.sort((a, b) => a.date.localeCompare(b.date)).map(r => <div key={r.id} style={css.rdvCard}>
            <div style={{ width: 3, borderRadius: 2, background: tc[r.type] || "#6366f1", flexShrink: 0 }} />
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: "#f1f5f9", marginBottom: 2 }}>{r.titre}</div>
              <div style={{ fontSize: 10, color: "#64748b", marginBottom: 4 }}>{r.contact}</div>
              <div style={{ display: "flex", gap: 6 }}><span style={css.flowBadge(tc[r.type] || "#6366f1")}>{r.type}</span><span style={{ fontSize: 10, color: "#475569" }}>{r.date} {r.heure}</span></div>
            </div>
            <button style={css.btnD} onClick={() => setRdvs(p => p.filter(x => x.id !== r.id))}>✕</button>
          </div>)}
        </div>
      </div>
      {showModal && <div style={css.overlay} onClick={() => setShowModal(false)}><div style={css.modal} onClick={e => e.stopPropagation()}>
        <div style={{ fontSize: 14, fontWeight: 800, color: "#e2e8f0", marginBottom: 16 }}>Nouveau RDV</div>
        {[{ k: "titre", l: "Titre", p: "Visite terrain..." }, { k: "contact", l: "Contact", p: "Nom entreprise" }, { k: "date", l: "Date", t: "date" }, { k: "heure", l: "Heure", t: "time" }].map(f => <div key={f.k} style={{ marginBottom: 10 }}>
          <div style={css.flbl}>{f.l}</div><input style={css.inp} type={f.t || "text"} placeholder={f.p} value={form[f.k]} onChange={e => setForm(p => ({ ...p, [f.k]: e.target.value }))} />
        </div>)}
        <div style={{ marginBottom: 12 }}><div style={css.flbl}>Type</div>
          <select style={css.sel} value={form.type} onChange={e => setForm(p => ({ ...p, type: e.target.value }))}>
            <option value="appel">Appel</option><option value="terrain">Visite terrain</option><option value="presentiel">Présentiel</option>
          </select>
        </div>
        <div style={{ display: "flex", gap: 8, marginTop: 14 }}><button style={css.btnP} onClick={create}>Créer</button><button style={css.btnG} onClick={() => setShowModal(false)}>Annuler</button></div>
      </div></div>}
    </div>
  );
}

function Automations({ autos, setAutos }) {
  const cc = { email: "#3b82f6", sms: "#10b981" };
  return (
    <div style={css.autoWrap}>
      <div style={{ fontSize: 15, fontWeight: 800, color: "#f1f5f9", marginBottom: 16 }}>Séquences de relance</div>
      {autos.map(a => <div key={a.id} style={css.autoCard}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
          <span style={css.flowBadge(cc[a.canal] || "#6366f1")}>{a.canal.toUpperCase()}</span>
          <div style={{ flex: 1, fontSize: 13, fontWeight: 700, color: "#f1f5f9" }}>{a.nom}</div>
          <button style={css.toggle(a.actif)} onClick={() => setAutos(p => p.map(x => x.id === a.id ? { ...x, actif: !x.actif } : x))}>
            <div style={css.toggleDot(a.actif)} />
          </button>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 7, fontSize: 11, color: "#64748b" }}>
          <span>Déclencheur :</span>
          <span style={css.flowBadge(stageColor(a.declencheur))}>{stageLabel(a.declencheur)}</span>
          <span>→ Délai : {a.delai === 0 ? "immédiat" : `J+${a.delai}`}</span>
        </div>
        {a.actif && <div style={css.statsRow}>
          {[{ l: "Envoyés", v: a.envoyes, c: "#f1f5f9" }, { l: "Taux ouverture", v: a.envoyes > 0 ? Math.round(a.ouverts / a.envoyes * 100) + "%" : "0%", c: "#f59e0b" }, { l: "Taux réponse", v: a.envoyes > 0 ? Math.round(a.reponses / a.envoyes * 100) + "%" : "0%", c: "#10b981" }].map(s => <div key={s.l} style={css.autoStat}>
            <div style={{ fontSize: 18, fontWeight: 800, color: s.c }}>{s.v}</div>
            <div style={{ fontSize: 10, color: "#475569", marginTop: 2 }}>{s.l}</div>
          </div>)}
        </div>}
      </div>)}
    </div>
  );
}

function Reporting({ contacts }) {
  const total = contacts.filter(c => !["gagne", "perdu"].includes(c.stage)).reduce((s, c) => s + c.valeur, 0);
  const gagne = contacts.filter(c => c.stage === "gagne").reduce((s, c) => s + c.valeur, 0);
  const perdu = contacts.filter(c => c.stage === "perdu").reduce((s, c) => s + c.valeur, 0);
  const tx = contacts.length > 0 ? Math.round(contacts.filter(c => c.stage === "gagne").length / contacts.length * 100) : 0;
  const maxV = Math.max(...STAGES.map(s => contacts.filter(c => c.stage === s.id).reduce((a, c) => a + c.valeur, 0)), 1);
  return (
    <div style={css.repWrap}>
      <div style={{ fontSize: 15, fontWeight: 800, color: "#f1f5f9", marginBottom: 16 }}>Tableau de bord</div>
      <div style={css.kpiGrid}>
        {[{ v: contacts.length, l: "Contacts total", sub: contacts.filter(c => c.stage === "nouveau").length + " nouveaux", c: "#f1f5f9" }, { v: eur(total), l: "Pipeline actif", sub: contacts.filter(c => !["gagne", "perdu"].includes(c.stage)).length + " opportunités", c: "#3b82f6" }, { v: eur(gagne), l: "Gagné", sub: "Conversion " + tx + "%", c: "#10b981" }, { v: eur(perdu), l: "Perdu", sub: contacts.filter(c => c.stage === "perdu").length + " dossiers", c: "#ef4444" }].map(k => <div key={k.l} style={css.kpiCard}>
          <div style={css.kpiVal(k.c)}>{k.v}</div>
          <div style={{ fontSize: 11, color: "#475569", marginTop: 5 }}>{k.l}</div>
          <div style={{ fontSize: 11, color: k.c === "#f1f5f9" ? "#64748b" : k.c, marginTop: 3, fontWeight: 600 }}>{k.sub}</div>
        </div>)}
      </div>
      <div style={{ background: "#0c1322", border: "1px solid #1a2540", borderRadius: 11, padding: 18 }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: "#e2e8f0", marginBottom: 14 }}>Valeur par stage</div>
        {STAGES.map(s => { const v = contacts.filter(c => c.stage === s.id).reduce((a, c) => a + c.valeur, 0); const p = Math.round(v / maxV * 100); return <div key={s.id} style={css.barRow}>
          <div style={css.barLbl}>{s.label}</div>
          <div style={css.barTrack}><div style={css.barFill(p, s.color)} /></div>
          <div style={{ width: 70, fontSize: 10, color: "#64748b", fontWeight: 700 }}>{v > 0 ? eur(v) : "—"}</div>
        </div>; })}
      </div>
    </div>
  );
}

function NewContact({ onClose, onSave }) {
  const [form, setForm] = useState({ nom: "", email: "", tel: "", stage: "nouveau", valeur: "", tags: "" });
  const save = () => { if (!form.nom.trim()) return; onSave({ id: genId(), ...form, valeur: parseFloat(form.valeur) || 0, tags: form.tags.split(",").map(t => t.trim()).filter(Boolean), notes: [], createdAt: TODAY, lastActivity: TODAY }); onClose(); };
  return <div style={css.overlay} onClick={onClose}><div style={css.modal} onClick={e => e.stopPropagation()}>
    <div style={{ fontSize: 14, fontWeight: 800, color: "#e2e8f0", marginBottom: 16 }}>Nouveau contact</div>
    {[{ k: "nom", l: "Nom / Entreprise *", p: "ex. Foncia Essonne" }, { k: "email", l: "Email", p: "contact@exemple.fr" }, { k: "tel", l: "Téléphone", p: "01 00 00 00 00" }, { k: "valeur", l: "Valeur (€)", p: "3500" }, { k: "tags", l: "Tags (virgule)", p: "Syndic, Toiture" }].map(f => <div key={f.k} style={{ marginBottom: 10 }}>
      <div style={css.flbl}>{f.l}</div><input style={css.inp} placeholder={f.p} value={form[f.k]} onChange={e => setForm(p => ({ ...p, [f.k]: e.target.value }))} />
    </div>)}
    <div style={{ marginBottom: 14 }}><div style={css.flbl}>Stage</div>
      <select style={css.sel} value={form.stage} onChange={e => setForm(p => ({ ...p, stage: e.target.value }))}>
        {STAGES.map(s => <option key={s.id} value={s.id}>{s.label}</option>)}
      </select>
    </div>
    <div style={{ display: "flex", gap: 8 }}><button style={css.btnP} onClick={save}>Créer</button><button style={css.btnG} onClick={onClose}>Annuler</button></div>
  </div></div>;
}

export default function App() {
  const [auth, setAuth] = useState(false);
  const [contacts, setContacts] = useState(INIT_CONTACTS);
  const [messages, setMessages] = useState(INIT_MESSAGES);
  const [rdvs, setRdvs] = useState(INIT_RDVS);
  const [autos, setAutos] = useState(INIT_AUTOS);
  const [view, setView] = useState("pipeline");
  const [selId, setSelId] = useState(null);
  const [search, setSearch] = useState("");
  const [showNew, setShowNew] = useState(false);

  if (!auth) return <Login onLogin={() => setAuth(true)} />;

  const selContact = contacts.find(c => c.id === selId);
  const totalP = contacts.filter(c => !["gagne", "perdu"].includes(c.stage)).reduce((s, c) => s + c.valeur, 0);
  const totalG = contacts.filter(c => c.stage === "gagne").reduce((s, c) => s + c.valeur, 0);

  const nav = [
    { sec: "CRM", items: [{ id: "pipeline", icon: "◫", l: "Pipeline", b: contacts.filter(c => c.stage === "nouveau").length }, { id: "contacts", icon: "👥", l: "Contacts", b: contacts.length }, { id: "conversations", icon: "💬", l: "Conversations", b: null }] },
    { sec: "Gestion", items: [{ id: "calendrier", icon: "📅", l: "Calendrier", b: rdvs.length }, { id: "automations", icon: "⚡", l: "Automations", b: autos.filter(a => a.actif).length }, { id: "reporting", icon: "📊", l: "Reporting", b: null }] },
  ];

  return (
    <div style={css.root}>
      <aside style={css.sidebar}>
        <div style={css.logo}><div style={css.logoMark}>K</div><div style={css.logoText}>KemiCRM</div></div>
        <nav style={css.nav}>
          {nav.map(s => <div key={s.sec}>
            <div style={css.navSec}>{s.sec}</div>
            {s.items.map(item => <button key={item.id} style={css.navBtn(view === item.id && !selId)} onClick={() => { setView(item.id); setSelId(null); }}>
              <span style={{ fontSize: 14, width: 16, textAlign: "center" }}>{item.icon}</span>
              {item.l}
              {item.b ? <span style={css.badge("#1a2540")}>{item.b}</span> : null}
            </button>)}
          </div>)}
        </nav>
        <div style={css.sideBot}>
          <div style={css.statsGrid}>
            <div style={css.statCard}><div style={css.statVal("#3b82f6")}>{eur(totalP)}</div><div style={css.statLbl}>Pipeline</div></div>
            <div style={css.statCard}><div style={css.statVal("#10b981")}>{eur(totalG)}</div><div style={css.statLbl}>Gagné</div></div>
          </div>
          <div style={css.userRow}><div style={css.av("#FA0A96", 30)}>MK</div><div><div style={{ fontSize: 12, fontWeight: 700, color: "#f1f5f9" }}>Mims</div><div style={{ fontSize: 10, color: "#334155" }}>Kemidrone</div></div></div>
        </div>
      </aside>
      <main style={css.main}>
        {!selId && <div style={css.topbar}>
          <input style={css.searchBox} placeholder="Rechercher contact, tag..." value={search} onChange={e => setSearch(e.target.value)} />
          <button style={css.btnP} onClick={() => setShowNew(true)}>+ Nouveau contact</button>
        </div>}
        <div style={css.content}>
          {selId && selContact ? <Fiche contact={selContact} contacts={contacts} setContacts={setContacts} messages={messages} setMessages={setMessages} onBack={() => setSelId(null)} />
          : view === "pipeline" ? <Pipeline contacts={contacts} setContacts={setContacts} onSelect={setSelId} />
          : view === "contacts" ? <Contacts contacts={contacts} setContacts={setContacts} search={search} onSelect={setSelId} />
          : view === "conversations" ? <Conversations contacts={contacts} messages={messages} setMessages={setMessages} />
          : view === "calendrier" ? <Calendrier rdvs={rdvs} setRdvs={setRdvs} />
          : view === "automations" ? <Automations autos={autos} setAutos={setAutos} />
          : view === "reporting" ? <Reporting contacts={contacts} />
          : null}
        </div>
      </main>
      {showNew && <NewContact onClose={() => setShowNew(false)} onSave={c => setContacts(p => [c, ...p])} />}
    </div>
  );
}